import { useHMSActions } from "@100mslive/react-sdk";
import { SYSTEM_MESSAGES, SYSTEM_TYPE } from "./constants";

export const useHMSSyncRoom = () => {
  const hmsActions = useHMSActions();
  return () =>
    hmsActions.sendBroadcastMessage(SYSTEM_MESSAGES.UPDATE_ROOM, SYSTEM_TYPE);
};
